/**
 * @author Vaibhav Raut <vaibhav@wemotiveforge.com>
 */

import React from 'react';
import {connect} from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Button, Checkbox, Col, Input, Layout, Row, Typography } from 'antd';

import {signUpRequest} from '../../AuthenticationApiActions';
import './SignUp.css';
import logo from '../../../../assets/logo.png';
import ConstantMessages from '../../../../utils/Strings';
import UtilHelper from "../../../../utils/UtilHelper";
import MessageModal from "../../../../utils/components/MessageModal/MessageModal";
import CustomFooter from "../../../Dashboard/components/CustomFooter/CustomFooter";
import GenaLoader from "../../../../utils/components/GenaLoader/GenaLoader";
import MobileNumber from "../../../../utils/components/MobileNumber/MobileNumber";
import {STATIC_URLS} from "../../../../utils/Constants";
import { ArrowRightOutlined, LockOutlined, MailFilled, MailOutlined, UserAddOutlined } from '@ant-design/icons';
// import appLogo from '../../../../assets/icons/genascreen-logo.png'
import appLogo from '../../../../assets/icons/genascreen-logo-white.png'
import CustomIcon from '../../../../utils/components/CustomIcon/CustomIcon'
const {Content, Header, Footer} = Layout;
const FormItem = Form.Item;

class SignUpForm extends React.Component {

  /**
   * This method is triggered when form is submitted by the user
   * @param e
   */
  handleSubmit = formData => {
    // e.preventDefault();

    this.setState({formSubmit: true}, () => {
      // this.props.form.validateFields((err, formData) => {
        // if (this.state.validPhoneNumber) {

          if (formData.phone?.charAt(0) !== '+') {
            formData.phone = `+${formData.phone}`
          }

          this.setState({showLoader: true}, () => {
            this.props.onSignUp(formData).then(() => {
              this.setState({showLoader: false}, () => {
                this.refs.messageModal.setState({
                  showModal: true, title: ConstantMessages.signupSuccessTitle,
                  message: ConstantMessages.signupSuccessMessage,
                  showOkButton: true,
                  handleOk: this.navigateToHome,
                  okText: 'Ok'
                });
              });
            }).catch(() => {
            }).finally(() => {
              this.setState({showLoader: false});
            });
          });
        // }
      // });
    });

  };
  navigateToHome = () => {
    window.location = '/';
  };

  updateMobileNumber = (phone, validPhoneNumber) => {
    this.setState({phone, validPhoneNumber});
  };

  acceptDisclaimer = e => {
    this.setState({disclaimerSelected: e.target.checked});
  };

  constructor(props) {
    super(props);

    this.state = {
      showLoader: false,
      formSubmit: false,
      phone: '',
      validPhoneNumber: false,
      disclaimerSelected: false
    };

  }

  /**
   * Render the UI of the login form
   * @returns {XML}
   */
  render() {
    const fieldValidationRules = {
      username: {
        rules: [
          {required: true, whitespace: true, message: ConstantMessages.emailAddressRequired},
          {type: 'email', message: ConstantMessages.enterValidEmailAddress},
        ],
      },
      firstName: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.firstNameRequired },
          { max: 50, message: 'Maximum 50 characters allowed' }
        ]
      },
      lastName: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.lastNameRequired },
          { max: 50, message: 'Maximum 50 characters allowed' }
        ]
      },
      location: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.locationRequired },
          { max: 255, message: 'Maximum 255 characters allowed' }
        ]
      },
      organization: {
        rules: [
          { required: true, whitespace: true, message: ConstantMessages.organizationRequired },
          { max: 255, message: 'Maximum 255 characters allowed' }
        ]
      }
    };

    return (
      <Layout className="signup-layout">
        <Header className="signup-layout-header">
          {/* Logo on the Left */}
          <img src={appLogo} alt='Application Logo' style={{ height: '48px' }} />
          <Button className="btn" ghost={true} href="/contact-us">
            Contact
            <CustomIcon name="OpenFolder" />
            {/* <MailFilled /> */}
          </Button>
        </Header>
        <Content className='signup-layout-content'>
          <div className="signup-container" style={{ width: '400px', backgroundColor: '#FFFFFF' }}>
            <div className="signup-container-header">
              <div className="flex-vertical-gap-1" style={{ alignItems: "center" }}>
                {/* <UserAddOutlined style={{ fontSize: '32px' }} /> */}
                <CustomIcon name="UserAddPlus" width={48} height={48} />
                <Typography.Title style={{ margin: 0 }} level={2}>
                  Sign Up
                </Typography.Title>
              </div>
              <Form form={this.props.form} layout="vertical" style={{ width: '100%', padding: '0px', backgroundColor: 'transparent' }} onFinish={this.handleSubmit}>

                <Form.Item name="firstName" label="First Name" rules={fieldValidationRules.firstName.rules}>
                  <Input placeholder="Enter first name" />
                </Form.Item>

                <Form.Item name='lastName' label="Last Name" rules={fieldValidationRules.lastName.rules}>
                  <Input placeholder="Enter last name" />
                </Form.Item>

                <Form.Item name='username' label="Email Address" rules={fieldValidationRules.username.rules}>
                  <Input placeholder="Enter email address"/>
                </Form.Item>

                <Form.Item name='location' label="Location" rules={fieldValidationRules.location.rules}>
                  <Input placeholder="Enter location"/>
                </Form.Item>

                <MobileNumber label="Mobile Number" name="phone" required />

                <Form.Item name='organization' label="Organization" rules={fieldValidationRules.organization.rules}>
                  <Input placeholder="Enter organization" />
                </Form.Item>

                {/* <Row>
                  <Col span={11}>
                    
                  </Col>

                  <Col offset={2} span={11}>
                    <div className="height-35"></div>
                    <Form.Item>
                      {getFieldDecorator('acceptCondition', fieldValidationRules.acceptCondition)(
                        <div>
                          <Checkbox onChange={this.acceptDisclaimer}></Checkbox>
                          <span>I accept the <a href={STATIC_URLS.DISCLAIMER} target='_blank' rel="noopener noreferrer">disclaimer</a></span>
                        </div>
                      )}
                      {
                        this.state.formSubmit && !this.state.disclaimerSelected ?
                          <div
                            className="error-terms-condition-not-selected">Please accept the disclaimer</div> : ''
                      }
                    </Form.Item>

                  </Col>
                </Row> */}

                <Form.Item>
                  <Button className="margin-top-2" block type="primary" htmlType="submit">
                    Sign Up
                    <CustomIcon name="LineArrowRight" />
                    {/* <ArrowRightOutlined /> */}
                  </Button>
                </Form.Item>

                <FormItem>
                  <div style={{ textAlign: 'center' }}>Already have an account?&nbsp;<Button href="/signin" type="link" style={{ padding: 0 }}>Login</Button></div>
                </FormItem>
     
              </Form>

            </div>

            <MessageModal
              ref="messageModal"
            />
          </div>
        </Content>
        {/* <Footer>
          <CustomFooter/>
        </Footer> */}
        <GenaLoader showLoader={this.state.showLoader}/>
      </Layout>
    )
  }

}

let SignUp = (props) => {
  const [form] = Form.useForm();
  return <SignUpForm form={form} {...props} />;
};


const mapStateToProps = state => {
  return {
    loggedInUser: state.auth.loggedInUser
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

    onSignUp: (data) => {
      return dispatch(signUpRequest(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    }

  }
};

SignUp = connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp);

export default SignUp;
